import React from "react";
import { Modal, Button } from "react-bootstrap";
import waringSign from "../assets/images/warnOmc.png";

const DeputationModal = ({ show, onClose }) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header style={{ background: "#921D1E", color: "white" }}>
        <div className="d-flex align-items-center justify-content-center w-100">
          <img src={waringSign} alt="warn" />
        </div>
      </Modal.Header>
      <Modal.Body>
        <h2
          style={{
            color: "#921D1E",
            fontSize: "28px",
            fontFamily: "Roboto",
            textAlign: "center",
          }}
        >
          Important Notice
        </h2>
        <p
          style={{
            fontSize: "16px",
            marginTop: "20px",
            fontFamily: "Roboto",
            textAlign: "center",
          }}
        >
          You are required to take a printout of the submitted application and
          send it through registered post along with necessary documents.
        </p>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Button
          variant="primary"
          onClick={onClose}
          style={{
            fontSize: "16px",
            fontWeight: "600",
            fontFamily: "Roboto",
            textAlign: "center",
            border: "1px solid #DEBBBB",
            color: "#921D1E",
            background: "#F9F3F4",
          }}
        >
          I Agree
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeputationModal;
